import React, { MouseEvent, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Stack,
  Tooltip,
  Typography,
  SnackbarProps,
  Chip,
} from "@mui/material";
import _debounce from "lodash/debounce";
// third-party

import { ColumnDef } from "@tanstack/react-table";
import { useQueryClient } from "@tanstack/react-query";

// project-import

import IconButton from "../../../../components/@extended/IconButton";
import { FormattedMessage } from "react-intl";

import ReusableActivateDialog from "../../../../components/ReusableComponent/ReusableActivateDialog";

// assets
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FilterOutlined,
  CloseOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

import { openSnackbar } from "../../../../api/snackbar";

import Loader from "../../../../components/Loader";

import FiltersModal, { ResumeFiltersType } from "./FiltersModal";
import { USERAXIOS } from "../../../../api/userAxios";
import ReusableTable from "../../../../components/ReusableComponent/ReusableTable";
import ReusableDeleteDialog from "../../../../components/ReusableComponent/ReusableDeleteDialog";
import { Resume } from "../../../../types/resumes-managment/resume";
import ExpandingResumeDetail from "./ExpandingResumeDetail";

const Resumes = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [openFilters, setOpenFilters] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<Resume[]>([]);
  const [currentPage, setCurrenttPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [tempSearchText, setTempSearchText] = useState("");
  const [countPage, setCountPage] = useState({
    current_page: 0,
    last_page: 0,
  });
  const [isDeleting, setIsDeleting] = useState(false);
  const [selected, setSelected] = useState<any>("");
  const [loadingSearsh, setLoadingSearch] = useState(false);
  const [expandedRowId, setExpandedRowId] = useState<string | number | null>(
    null
  );

  const [activateModal, setActivateModal] = useState(false);
  const [activateLoading, setActivateLoading] = useState(false);
  const [activateTarget, setActivateTarget] = useState<Resume | null>(null);

  const handleClose = () => {
    setOpen(!open);
  };

  const handleSearch = () => {
    setLoadingSearch(true);
    setCurrenttPage(1);
    setSearchText(tempSearchText);
    setLoadingSearch(false);
  };

  const columns = useMemo<ColumnDef<Resume>[]>(
    () => [
      {
        header: () => <FormattedMessage id="ID" />,
        accessorKey: "id",
        meta: { className: "cell-center" },
        cell: ({ row }) => (
          <Typography variant="subtitle1">{row.original.id}</Typography>
        ),
      },

      {
        header: () => <FormattedMessage id="User Name" />,
        accessorKey: "user_name",
        meta: { className: "cell-center" },
        cell: ({ row }) => (
          <Typography variant="subtitle2">{row.original.user_name}</Typography>
        ),
      },
      {
        header: () => <FormattedMessage id="Email" />,
        accessorKey: "email",
        meta: { className: "cell-center" },
        cell: ({ row }) => (
          <Typography variant="subtitle2">{row.original.email}</Typography>
        ),
      },
      {
        header: () => <FormattedMessage id="Language" />,
        accessorKey: "lang",
        meta: { className: "cell-center" },
        cell: ({ row }) => (
          <Typography variant="subtitle2">{row.original.lang}</Typography>
        ),
      },

      // {
      //   header: () => <FormattedMessage id="Objectives" />,
      //   accessorKey: "objectives",
      //   meta: { className: "cell-center" },
      //   cell: ({ row }) => (
      //     <Typography variant="subtitle2">{row.original.objectives}</Typography>
      //   ),
      // },

      // {
      //   header: () => <FormattedMessage id="Country" />,
      //   accessorKey: "country",
      //   meta: { className: "cell-center" },
      //   cell: ({ row }) => (
      //     <Typography variant="subtitle2">{row.original.country}</Typography>
      //   ),
      // },
      // {
      //   header: () => <FormattedMessage id="city" />,
      //   accessorKey: "city",
      //   meta: { className: "cell-center" },
      //   cell: ({ row }) => (
      //     <Typography variant="subtitle2">{row.original.city}</Typography>
      //   ),
      // },

      {
        header: () => <FormattedMessage id="Created At" />,
        accessorKey: "created_at",
        meta: { className: "cell-center" },
        cell: ({ row }) => (
          <Typography variant="subtitle2">{row.original.created_at}</Typography>
        ),
      },
      {
        header: () => <FormattedMessage id="updated at" />,
        accessorKey: "updated_at",
        meta: { className: "cell-center" },
        cell: ({ row }) => (
          <Typography variant="subtitle2">{row.original.updated_at}</Typography>
        ),
      },
      // {
      //   header: () => <FormattedMessage id="Read" />,
      //   accessorKey: "read",
      //   meta: { className: "cell-center" },
      //   cell: ({ row }) => (
      //     <Chip
      //       color={row.original.read ? "success" : "error"}
      //       label={
      //         row.original.read ? (
      //           <FormattedMessage id="Read" />
      //         ) : (
      //           <FormattedMessage id="Unread" />
      //         )
      //       }
      //       size="small"
      //       variant="filled"
      //     />
      //   ),
      // },
      {
        header: () => <FormattedMessage id="Status" />,
        accessorKey: "status",
        meta: { className: "cell-center" },
        cell: ({ row }) => (
          <Chip
            color={row.original.status ? "success" : "error"}
            label={
              row.original.status ? (
                <FormattedMessage id="Active" />
              ) : (
                <FormattedMessage id="Inactive" />
              )
            }
            size="small"
            variant="filled"
          />
        ),
      },
      {
        header: () => <FormattedMessage id="Actions" />,
        accessorKey: "actions",
        meta: { className: "cell-center" },
        disableSortBy: true,
        cell: ({ row }) => {
          // const isExpanded = String(expandedRowId) === String(row.original.id);
          // const collapseIcon = isExpanded ? (
          //   <CloseOutlined style={{ color: theme.palette.error.main }} />
          // ) : (
          //   <EyeOutlined />
          // );
          return (
            <Stack direction="row" spacing={0}>
              <Tooltip title={row.original.status ? "Active" : "Unactive"}>
                <IconButton
                  color={row.original.status ? "success" : "error"}
                  onClick={(e: MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    setActivateTarget(row.original);
                    setActivateModal(true);
                  }}
                  sx={{ "&:hover": { backgroundColor: "transparent" } }}
                >
                  <CheckCircleOutlined
                    style={{
                      color: row.original.status ? "error" : "success",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {/* <Tooltip title={isExpanded ? "close details" : "view details"}>
                <IconButton
                  color="primary"
                  onClick={(e: MouseEvent<HTMLButtonElement>) => {
                    setExpandedRowId(
                      isExpanded ? null : String(row.original.id)
                    );
                  }}
                  sx={{ "&:hover": { backgroundColor: "transparent" } }}
                >
                  {collapseIcon}
                </IconButton>
              </Tooltip> */}
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  onClick={(e: MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    // setSelectedCustomer(row.original);
                    // setCustomerModal(true);
                    navigate(`/resumes/edit-resume/${row.original.id}`);
                  }}
                  sx={{ "&:hover": { backgroundColor: "transparent" } }}
                >
                  <EditOutlined />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  color="error"
                  onClick={(e: MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    handleClose();
                    setSelected(row.original);
                  }}
                >
                  <DeleteOutlined />
                </IconButton>
              </Tooltip>
            </Stack>
          );
        },
      },
    ],
    [theme, expandedRowId]
  );

  const fetchData = () => {
    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);

    const requested_resume_language = urlParams.get(
      "requested_resume_language"
    );
    const desired_work_department = urlParams.get("desired_work_department");
    const country_id = urlParams.get("country_id");
    const city_id = urlParams.get("city_id");
    const targeted_job_type = urlParams.get("targeted_job_type");
    const foreign_languages = urlParams.get("foreign_languages");
    const gender = urlParams.get("gender");
    const military_service = urlParams.get("military_service");
    const photo_included = urlParams.get("photo_included");
    const status = urlParams.get("status");

    USERAXIOS.get(
      `/resumes?page=${currentPage}` +
        (searchText ? `&id=${searchText}` : "") +
        (requested_resume_language
          ? `&requested_resume_language=${requested_resume_language}`
          : "") +
        (desired_work_department
          ? `&desired_work_department=${desired_work_department}`
          : "") +
        (country_id ? `&country_id=${country_id}` : "") +
        (city_id ? `&city_id=${city_id}` : "") +
        (targeted_job_type ? `&targeted_job_type=${targeted_job_type}` : "") +
        (foreign_languages ? `&foreign_languages=${foreign_languages}` : "") +
        (gender ? `&gender=${gender}` : "") +
        (military_service ? `&military_service=${military_service}` : "") +
        (photo_included ? `&photo_included=${photo_included}` : "") +
        (status ? `&status=${!!(status === "Active")}` : "")
    )
      .then((response) => {
        const { data, meta } = response.data;
        const fetchedProfiles = data;
        const rowsWithKeys = fetchedProfiles.map((profile) => ({
          ...profile,
          key: profile.id,
        }));
        setResult(rowsWithKeys);
        setLoading(false);
        setCountPage(meta);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching resume profiles:", error);
        openSnackbar({
          open: true,
          message: "Error fetching resume profiles",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "error",
          },
        } as SnackbarProps);
      });
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchText]);

  useEffect(() => {
    fetchData();
  }, [location.search]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrenttPage(page); // Update the currentPage state when the page changes
  };

  const handleFiltersClose = () => {
    setOpenFilters(false);
  };

  const clearFilters = () => {
    setLoading(true);
    window.history.pushState({}, "", `${window.location.pathname}`);
    USERAXIOS.get(
      `/resumes?page=${currentPage}` + (searchText ? `&id=${searchText}` : "")
    )
      .then((response) => {
        const { data, meta } = response.data;
        const fetchedProfiles = data;
        const rowsWithKeys = fetchedProfiles.map((profile) => ({
          ...profile,
          key: profile.id,
        }));
        setResult(rowsWithKeys);
        setLoading(false);
        setCountPage(meta);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching resume profiles:", error);
        openSnackbar({
          open: true,
          message: "Error fetching resume profiles",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "error",
          },
        } as SnackbarProps);
      });
  };

  const hasActiveFilters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return !!(
      urlParams.get("requested_resume_language") ||
      urlParams.get("desired_work_department") ||
      urlParams.get("country_id") ||
      urlParams.get("city_id") ||
      urlParams.get("targeted_job_type") ||
      urlParams.get("foreign_languages") ||
      urlParams.get("gender") ||
      urlParams.get("military_service") ||
      urlParams.get("photo_included") ||
      urlParams.get("status")
    );
  };

  const handleFiltersApply = (filters: ResumeFiltersType) => {
    setLoading(true);
    const {
      requested_resume_language,
      desired_work_department,
      country_id,
      city_id,
      targeted_job_type,
      foreign_languages,
      gender,
      military_service,
      photo_included,
      status,
    } = filters;
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete("requested_resume_language");
    urlParams.delete("desired_work_department");
    urlParams.delete("country_id");
    urlParams.delete("city_id");
    urlParams.delete("targeted_job_type");
    urlParams.delete("foreign_languages");
    urlParams.delete("gender");
    urlParams.delete("military_service");
    urlParams.delete("photo_included");
    urlParams.delete("status");

    if (requested_resume_language)
      urlParams.set("requested_resume_language", requested_resume_language);
    if (desired_work_department)
      urlParams.set("desired_work_department", desired_work_department);
    if (country_id) urlParams.set("country_id", country_id);
    if (city_id) urlParams.set("city_id", city_id);
    if (targeted_job_type)
      urlParams.set("targeted_job_type", targeted_job_type);
    if (foreign_languages)
      urlParams.set("foreign_languages", foreign_languages);
    if (gender) urlParams.set("gender", gender);
    if (military_service) urlParams.set("military_service", military_service);
    if (photo_included) urlParams.set("photo_included", photo_included);
    if (status) urlParams.set("status", status);

    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;

    window.history.pushState({}, "", newUrl);

    USERAXIOS.get(
      `/resumes?page=${currentPage}` +
        (requested_resume_language
          ? `&requested_resume_language=${requested_resume_language}`
          : "") +
        (desired_work_department
          ? `&desired_work_department=${desired_work_department}`
          : "") +
        (country_id ? `&country_id=${country_id}` : "") +
        (city_id ? `&city_id=${city_id}` : "") +
        (targeted_job_type ? `&targeted_job_type=${targeted_job_type}` : "") +
        (foreign_languages ? `&foreign_languages=${foreign_languages}` : "") +
        (gender ? `&gender=${gender}` : "") +
        (military_service ? `&military_service=${military_service}` : "") +
        (photo_included ? `&photo_included=${photo_included}` : "") +
        (searchText ? `&id=${searchText}` : "") +
        (status ? `&status=${!!(status === "Active")}` : "")
    )
      .then((response) => {
        const { data, meta } = response.data;
        const fetchedProfiles = data;
        const rowsWithKeys = fetchedProfiles.map((profile) => ({
          ...profile,
          key: profile.id,
        }));
        setResult(rowsWithKeys);
        setLoading(false);
        setCountPage(meta);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching resume:", error);
        openSnackbar({
          open: true,
          message: "Error fetching resume",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "error",
          },
        } as SnackbarProps);
      });
  };

  const handleDelete = async () => {
    if (!selected?.id) return;
    setIsDeleting(true);
    try {
      await USERAXIOS.delete(`/resumes/${selected?.id}`);
      setResult((prevResults: any[]) =>
        prevResults.filter((item) => item.id !== selected?.id)
      );
      queryClient.invalidateQueries({ queryKey: ["resumes"] });
      openSnackbar({
        open: true,
        message: "Resume deleted successfully",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        close: false,
        alert: {
          color: "success",
        },
      } as SnackbarProps);
      if (handleClose) handleClose();
    } catch (error: any) {
      openSnackbar({
        open: true,
        message: error?.response?.data?.message || "Failed to delete resumes",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "error",
        },
      } as SnackbarProps);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleActivate = async () => {
    if (!activateTarget) return;
    setActivateLoading(true);
    try {
      if (activateTarget?.status) {
        await USERAXIOS.post(`/resumes/deactivate/${activateTarget?.id}`);
      } else {
        await USERAXIOS.post(`/resumes/activate/${activateTarget?.id}`);
      }
      setResult((prevResults: Resume[]) =>
        prevResults.map((item) =>
          item.id === activateTarget?.id
            ? { ...item, status: !item.status }
            : item
        )
      );
      // Invalidate job seekers queries since resumes and job seekers are related
      queryClient.invalidateQueries({ queryKey: ["jobSeekers"] });
      setActivateModal(false);
      setActivateTarget(null);
      openSnackbar({
        open: true,
        message: `Resume ${
          activateTarget.status ? "deactivated" : "activated"
        } successfully`,
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: { color: "success" },
      } as SnackbarProps);
    } catch (error: any) {
      openSnackbar({
        open: true,
        message:
          error?.response?.data?.message || "Failed to update resume status",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: { color: "error" },
      } as SnackbarProps);
    } finally {
      setActivateLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            {hasActiveFilters() && (
              <Button
                variant="outlined"
                color="primary"
                onClick={clearFilters}
                sx={{ mb: 2, padding: ".3rem 2rem " }}
              >
                <FormattedMessage id="Clear Filters" />
              </Button>
            )}
            <Button
              variant="contained"
              startIcon={<FilterOutlined />}
              onClick={() => setOpenFilters(true)}
              sx={{
                mb: 2,
                padding: ".3rem 2rem",
                gap: ".5rem",
              }}
            >
              <FormattedMessage id="Filters" />
            </Button>
          </Box>
          <ReusableTable
            data={result}
            columns={columns}
            countPage={countPage}
            handlePageChange={handlePageChange}
            handleSearchChange={handleSearch}
            currentPage={currentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setCurrenttPage={setCurrenttPage}
            loadingSearsh={loadingSearsh}
            searchedtext={tempSearchText}
            setSearchedtext={setTempSearchText}
            // modalToggler={() => {
            //   navigate("/resumes/add-resume");

            //   // setCustomerModal(true);
            //   // setSelectedCustomer(null);
            // }}
            renderDetailPanel={({ row }: any) => (
              <ExpandingResumeDetail data={row.original} />
            )}
            expandedRowId={expandedRowId}
            setExpandedRowId={setExpandedRowId}
          />
        </>
      )}
      {openFilters && (
        <FiltersModal
          open={openFilters}
          handleClose={handleFiltersClose}
          onApplyFilters={handleFiltersApply}
          onClearFilters={clearFilters}
        />
      )}
      <ReusableDeleteDialog
        open={open}
        handleClose={handleClose}
        handleDelete={handleDelete}
        isDeleting={isDeleting}
      />

      <ReusableActivateDialog
        open={activateModal}
        handleClose={() => setActivateModal(false)}
        handleActivate={handleActivate}
        title={
          activateTarget?.user_name ||
          activateTarget?.email ||
          String(activateTarget?.id) ||
          "Resume"
        }
        isActivating={activateLoading}
        isActive={!!activateTarget?.status}
      />
    </>
  );
};

export default Resumes;
